import * as api from "../api/index";

export const updateUser = async (formData) => {
  try {
    const { data } = await api.updateUser(formData);
    return data;
  } catch (error) {
    console.log("my Auth Error", error);
  }
};

export const searchUsers = async (formData) => {
  try {
    const { data } = await api.searchUsers(formData);
    return data;
  } catch (error) {
    console.log("My Search Error", error);
  }
};
